<template>
  <create-account-layout
    :current-step="2"
    :title="
      challenge_failed == true ? 'Verification Failed' : 'Carrier Details'
    "
  >
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div v-if="challenge_failed == false">
        <div class="flex flex-col items-start">
          <p class="flex flex-col pb-2 text-left text-sm">
            {{ challengeQuestion }}
          </p>
          <round-radio-button
            v-for="(option, index) in challengeAnswerOptions"
            :key="`challenge-question-option-${index}`"
            :class="
              carrier_verification_answer === option
                ? 'mb-2 w-full border-yellow-500'
                : 'mb-2 w-full'
            "
            :item="option"
            :value="option"
            name="verification_challenge"
            :handle-click="() => handleUpdate(option)"
            :checked="carrier_verification_answer === option"
          />
        </div>
        <button-main
          class="my-3 mb-4"
          :disabled="!carrier_verification_answer"
          type="submit"
          :loading-spinner="isLoading"
          value="Continue"
        />
      </div>
      <div v-else>
        <div class="flex flex-col items-start">
          <p class="flex flex-col pb-2 text-left text-sm">
            You have failed the validation process required to join this
            carrier.
          </p>
          <p class="flex flex-col pb-2 text-left text-sm">
            If you would like to continue the validation process, please click
            the button below to contact us so that we may assist you in
            verifying your account.
          </p>
        </div>
        <button-main
          class="my-3 mb-4"
          :disabled="false"
          type="button"
          value="Contact Highway"
          @click="showContactUsModal = true"
        >
          Contact Highway
        </button-main>
      </div>
    </form>
  </create-account-layout>
  <contact-us-modal
    v-if="showContactUsModal"
    :visible="showContactUsModal"
    @close="onCloseContactUsModal"
  />
</template>

<script>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import contactUs from '@/mixins/contactUs';
// import { toastResponse } from "@/common/handleServerResponse";

export default {
  name: 'VerificationChallenge',
  components: {
    CreateAccountLayout,
    ButtonMain,
    RoundRadioButton,
  },
  mixins: [contactUs],
  data() {
    return {
      isLoading: false,
      carrier_verification_answer: '',
      challenge_failed: false,
      showContactUsModal: false,
    };
  },
  computed: {
    challengeQuestion() {
      return this.$store.state.verifications?.challenge_question;
    },
    challengeAnswerOptions() {
      return this.$store.state.verifications?.challenge_question_answer_options;
    },
    company_type() {
      return this.$store.state.signUpData?.company_type;
    },
    isEmailRequiredForLogin() {
      return this.$store.state.carriers?.isEmailRequiredForLogin || false;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('users/refreshCurrentUser');
    } catch (error) {
      console.error('ERROR:', error);
      this.$router.push({ name: 'RequestAccess' });
    }
  },
  methods: {
    handleUpdate(value) {
      this.carrier_verification_answer = value;
      this.$store.commit('verifications/setChallengeAnswer', value);
    },
    async handleSubmit() {
      this.isLoading = true;
      try {
        const resChallenge = await this.$store.dispatch(
          'verifications/verifyChallengeQuestion'
        );
        if (resChallenge == 'challenge_successful') {
          this.isLoading = true;
          this.validation_error = false;
          const res = await this.$store.dispatch('users/hasCarrierBeenClaimed');
          if (res.status === 200) {
            this.$store.commit('carriers/setMaskedContacts', res.data);
          }
          if (res.status === 200) {
            this.$router.push({
              name: 'RequestAccessFMSCA',
              params: { carrierHasBeenClaimed: true },
            });
          } else if (res.status === 404) {
            if (this.isEmailRequiredForLogin == true) {
              this.$router.push({
                name: 'FMSCAAccountVerification',
                params: { canMoveOn: true },
              });
            } else {
              this.$router.push({
                name: 'FMSCAAccountVerification',
                params: { canMoveOn: true },
              });
            }
          }
        } else {
          this.validation_error = true;
          this.challenge_failed = true;
        }
        this.isLoading = false;
      } catch (error) {
        console.log('ERROR: ', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
